// ISO 27001:2022 Data
// Separated into:
// 1. ISMS Requirements (clauses 4-10) - Mandatory management system requirements
// 2. Annex A Controls (93 controls) - Security controls organized by category

// ISMS Requirements (clauses 4-10) - Mandatory management system requirements
export const ismsRequirements = [
  {
    id: 'ISMS-4.1',
    name: 'Understanding the organization and its context',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall determine external and internal issues that are relevant to its purpose and that affect its ability to achieve the intended outcome(s) of its information security management system.'
  },
  {
    id: 'ISMS-4.2',
    name: 'Understanding the needs and expectations of interested parties',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall determine the interested parties that are relevant to the information security management system and the requirements of these interested parties.'
  },
  {
    id: 'ISMS-4.3',
    name: 'Determining the scope of the information security management system',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall determine the boundaries and applicability of the information security management system to establish its scope.'
  },
  {
    id: 'ISMS-4.4',
    name: 'Information security management system',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall establish, implement, maintain and continually improve an information security management system, including the processes needed and their interactions, in accordance with the requirements of this document.'
  },
  {
    id: 'ISMS-5.1',
    name: 'Leadership and commitment',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Top management shall demonstrate leadership and commitment with respect to the information security management system.'
  },
  {
    id: 'ISMS-5.2',
    name: 'Policy',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Top management shall establish an information security policy.'
  },
  {
    id: 'ISMS-5.3',
    name: 'Organizational roles, responsibilities and authorities',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Top management shall ensure that the responsibilities and authorities for roles relevant to information security are assigned and communicated within the organization.'
  },
  {
    id: 'ISMS-6.1',
    name: 'Actions to address risks and opportunities',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'When planning for the information security management system, the organization shall consider the issues referred to in 4.1 and the requirements referred to in 4.2 and determine the risks and opportunities that need to be addressed.'
  },
  {
    id: 'ISMS-6.2',
    name: 'Information security objectives and planning to achieve them',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall establish information security objectives at relevant functions and levels.'
  },
  {
    id: 'ISMS-7.1',
    name: 'Resources',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall determine and provide the resources needed for the establishment, implementation, maintenance and continual improvement of the information security management system.'
  },
  {
    id: 'ISMS-7.2',
    name: 'Competence',
    type: 'Requirement',
    category: 'People',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall determine the necessary competence of person(s) doing work under its control that affects the information security performance.'
  },
  {
    id: 'ISMS-7.3',
    name: 'Awareness',
    type: 'Requirement',
    category: 'People',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Personnel doing work under the organization\'s control shall be aware of the information security policy and their contribution to the effectiveness of the information security management system.'
  },
  {
    id: 'ISMS-7.4',
    name: 'Communication',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall determine the need for internal and external communications relevant to the information security management system.'
  },
  {
    id: 'ISMS-7.5',
    name: 'Documented information',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization\'s information security management system shall include documented information required by this document and documented information determined by the organization as being necessary for the effectiveness of the information security management system.'
  },
  {
    id: 'ISMS-8.1',
    name: 'Operational planning and control',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall plan, implement and control the processes needed to meet information security requirements and to implement the actions determined in 6.1.'
  },
  {
    id: 'ISMS-9.1',
    name: 'Monitoring, measurement, analysis and evaluation',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall evaluate the information security performance and the effectiveness of the information security management system.'
  },
  {
    id: 'ISMS-9.2',
    name: 'Internal audit',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall conduct internal audits at planned intervals to provide information on whether the information security management system conforms to the organization\'s own requirements for its information security management system and to the requirements of this document.'
  },
  {
    id: 'ISMS-9.3',
    name: 'Management review',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Top management shall review the organization\'s information security management system at planned intervals to ensure its continuing suitability, adequacy and effectiveness.'
  },
  {
    id: 'ISMS-10.1',
    name: 'Continual improvement',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall continually improve the suitability, adequacy and effectiveness of the information security management system.'
  },
  {
    id: 'ISMS-10.2',
    name: 'Nonconformity and corrective action',
    type: 'Requirement',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'When a nonconformity occurs, the organization shall react to the nonconformity and take action to control and correct it and deal with the consequences.'
  }
];

// Annex A Controls (93 controls organized by category)
export const iso27001Controls = [
  // A.5 Organizational controls (37 controls)
  {
    id: '5.1',
    name: 'Policies for information security',
    type: 'Control',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'A set of policies for information security shall be defined, approved by management, published, communicated to and acknowledged by relevant personnel, and reviewed at planned intervals and if significant changes occur.'
  },
  {
    id: '5.2',
    name: 'Information security roles and responsibilities',
    type: 'Control',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information security roles and responsibilities shall be defined and allocated according to the organization\'s needs.'
  },
  {
    id: '5.3',
    type: 'Control',
    name: 'Segregation of duties',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Conflicting duties and conflicting areas of responsibility shall be segregated to reduce opportunities for unauthorized or unintentional modification or misuse of the organization\'s assets.'
  },
  {
    id: '5.4',
    type: 'Control',
    name: 'Management responsibilities',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Management shall require all personnel to apply information security in accordance with the established information security policy, topic-specific policies and procedures of the information security management system.'
  },
  {
    id: '5.5',
    name: 'Contact with authorities',
    type: 'Control',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall establish and maintain contact with relevant authorities.'
  },
  {
    id: '5.6',
    name: 'Contact with special interest groups',
    type: 'Control',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall establish and maintain contact with special interest groups or other specialist security forums and professional associations.'
  },
  {
    id: '5.7',
    type: 'Control',
    name: 'Threat intelligence',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information relating to information security threats shall be collected and analyzed to produce threat intelligence.'
  },
  {
    id: '5.8',
    type: 'Control',
    name: 'Information security in project management',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information security shall be integrated into project management.'
  },
  {
    id: '5.9',
    type: 'Control',
    name: 'Inventory of information and other associated assets',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'An inventory of information and other associated assets, including owners, shall be developed and maintained.'
  },
  {
    id: '5.10',
    type: 'Control',
    name: 'Acceptable use of information and other associated assets',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Rules for the acceptable use and procedures for handling information and other associated assets shall be identified, documented and implemented.'
  },
  {
    id: '5.11',
    type: 'Control',
    name: 'Return of assets',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'All personnel and external party users shall return all of the organization\'s assets in their possession upon change or termination of their employment, contract or agreement.'
  },
  {
    id: '5.12',
    type: 'Control',
    name: 'Classification of information',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information shall be classified according to the information security needs of the organization based on confidentiality, integrity, availability and relevant interested parties\' requirements.'
  },
  {
    id: '5.13',
    type: 'Control',
    name: 'Labelling of information',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'An appropriate set of procedures for information labelling shall be developed and implemented in accordance with the information classification scheme adopted by the organization.'
  },
  {
    id: '5.14',
    type: 'Control',
    name: 'Information transfer',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Legal, regulatory and contractual requirements for information transfer shall be identified and documented, and procedures for transferring information shall be established and implemented.'
  },
  {
    id: '5.15',
    type: 'Control',
    name: 'Access control',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Rules to control physical and logical access to information and other associated assets shall be established, documented and reviewed based on business and information security requirements.'
  },
  {
    id: '5.16',
    type: 'Control',
    name: 'Identity management',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The full life cycle of identities shall be managed.'
  },
  {
    id: '5.17',
    type: 'Control',
    name: 'Authentication information',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Allocation and management of authentication information shall be controlled by a management process, including advising personnel on the appropriate handling of authentication information.'
  },
  {
    id: '5.18',
    type: 'Control',
    name: 'Access rights',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Access rights to information and other associated assets shall be provisioned, reviewed, adjusted and removed in accordance with the topic-specific policy on access control.'
  },
  {
    id: '5.19',
    type: 'Control',
    name: 'Information security in supplier relationships',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Processes and procedures shall be defined and implemented to manage the information security risks associated with the use of supplier products and services.'
  },
  {
    id: '5.20',
    type: 'Control',
    name: 'Addressing information security within supplier agreements',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Relevant information security requirements shall be established and agreed with each supplier that may access, process, store, communicate, or provide IT infrastructure components for, the organization\'s information.'
  },
  {
    id: '5.21',
    type: 'Control',
    name: 'Managing information security in the ICT supply chain',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Processes and procedures shall be defined and implemented to manage information security risks within the ICT products and services supply chain.'
  },
  {
    id: '5.22',
    name: 'Monitoring, review and change management of supplier services',
    type: 'Control',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall regularly monitor, review, evaluate and manage change in supplier information security practices and service delivery.'
  },
  {
    id: '5.23',
    type: 'Control',
    name: 'Information security for use of cloud services',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Processes for acquisition, use, management and exit from cloud services shall be established in accordance with the organization\'s information security requirements.'
  },
  {
    id: '5.24',
    type: 'Control',
    name: 'Information security incident management planning and preparation',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Processes and procedures shall be established and maintained to ensure a quick, effective and orderly response to information security incidents.'
  },
  {
    id: '5.25',
    type: 'Control',
    name: 'Assessment and decision on information security events',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information security events shall be assessed and it shall be decided if they are to be classified as information security incidents.'
  },
  {
    id: '5.26',
    type: 'Control',
    name: 'Response to information security incidents',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information security incidents shall be responded to in accordance with the documented procedures.'
  },
  {
    id: '5.27',
    type: 'Control',
    name: 'Learning from information security incidents',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Knowledge gained from analyzing and resolving information security incidents shall be used to reduce the likelihood or impact of future incidents.'
  },
  {
    id: '5.28',
    name: 'Collection of evidence',
    type: 'Control',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall establish and implement procedures for the identification, collection, acquisition and preservation of information that can serve as evidence.'
  },
  {
    id: '5.29',
    name: 'Information security during disruption',
    type: 'Control',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall plan how to maintain information security at an appropriate level during disruption.'
  },
  {
    id: '5.30',
    type: 'Control',
    name: 'ICT readiness for business continuity',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'ICT readiness shall be planned, implemented, maintained and tested based on business continuity objectives and ICT continuity requirements.'
  },
  {
    id: '5.31',
    type: 'Control',
    name: 'Legal, statutory, regulatory and contractual requirements',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Legal, statutory, regulatory and contractual requirements relevant to information security and the organization\'s approach to meet these requirements shall be identified, documented and kept up to date.'
  },
  {
    id: '5.32',
    name: 'Intellectual property rights',
    type: 'Control',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall implement appropriate procedures to ensure compliance with legal, statutory, regulatory and contractual requirements related to intellectual property rights.'
  },
  {
    id: '5.33',
    type: 'Control',
    name: 'Protection of records',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Records shall be protected from loss, destruction, falsification, unauthorized access and unauthorized release, in accordance with legal, statutory, regulatory, contractual and business requirements.'
  },
  {
    id: '5.34',
    type: 'Control',
    name: 'Privacy and protection of personally identifiable information',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Privacy and protection of personally identifiable information shall be ensured as required in relevant legal, statutory, regulatory and contractual requirements.'
  },
  {
    id: '5.35',
    type: 'Control',
    name: 'Independent information security reviews',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization\'s information security implementation and its effectiveness (including people, processes and technology) shall be reviewed independently at planned intervals or when significant changes occur.'
  },
  {
    id: '5.36',
    type: 'Control',
    name: 'Compliance with policies, rules and standards for information security',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Compliance with the organization\'s information security policy, topic-specific policies, rules and standards shall be regularly reviewed.'
  },
  {
    id: '5.37',
    type: 'Control',
    name: 'Documented operating procedures',
    category: 'Organizational',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Operating procedures for information processing facilities shall be documented, maintained and made available to all personnel who need them.'
  },

  // A.6 People controls (8 controls)
  {
    id: '6.1',
    name: 'Screening',
    type: 'Control',
    category: 'People',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Prior to employment, contract or agreement, background verification checks on all candidates for employment, contractors and third-party users shall be carried out in accordance with relevant laws, regulations and ethics, and proportional to the business requirements, the classification of the information to be accessed and the perceived risk.'
  },
  {
    id: '6.2',
    type: 'Control',
    name: 'Terms and conditions of employment',
    category: 'People',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The contractual agreements with personnel and interested parties shall state their and the organization\'s responsibilities for information security.'
  },
  {
    id: '6.3',
    type: 'Control',
    name: 'Information security awareness, education and training',
    category: 'People',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Personnel and relevant interested parties shall receive appropriate information security awareness, education and training and regular updates of the organization\'s information security policy, topic-specific policies and procedures, as relevant for their job function.'
  },
  {
    id: '6.4',
    type: 'Control',
    name: 'Disciplinary process',
    category: 'People',
    status: 'Implemented',
    applicability: 'Included',
    description: 'A formal disciplinary process for personnel who have committed an information security breach shall be established and communicated.'
  },
  {
    id: '6.5',
    type: 'Control',
    name: 'Responsibilities after termination or change of employment',
    category: 'People',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information security responsibilities and duties that remain valid after termination or change of employment shall be defined, enforced and communicated to relevant personnel and interested parties.'
  },
  {
    id: '6.6',
    type: 'Control',
    name: 'Confidentiality or non-disclosure agreements',
    category: 'People',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Confidentiality or non-disclosure agreements reflecting the organization\'s needs for the protection of information shall be identified, documented, regularly reviewed and signed by personnel and relevant interested parties.'
  },
  {
    id: '6.7',
    type: 'Control',
    name: 'Remote working',
    category: 'People',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information security policy and supporting security measures shall be implemented to protect information accessed, processed or stored at remote working sites.'
  },
  {
    id: '6.8',
    type: 'Control',
    name: 'Information security event reporting',
    category: 'People',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Personnel and contractors using the organization\'s information systems and services shall be required to note and report any observed or suspected information security weaknesses in systems or services, or threats to systems or services, promptly to the organization\'s point of contact.'
  },

  // A.7 Physical controls (14 controls)
  {
    id: '7.1',
    name: 'Physical security perimeters',
    type: 'Control',
    category: 'Physical',
    status: 'Excluded',
    applicability: 'Excluded',
    description: 'Security perimeters shall be defined and used to protect areas that contain either sensitive or critical information and information processing facilities. (Excluded: AWS handles physical security perimeters for cloud infrastructure)'
  },
  {
    id: '7.2',
    type: 'Control',
    name: 'Physical entry controls',
    category: 'Physical',
    status: 'Excluded',
    applicability: 'Excluded',
    description: 'Secure areas shall be protected by appropriate entry controls to ensure that only authorized personnel are allowed access. (Excluded: AWS handles physical entry controls for cloud infrastructure)'
  },
  {
    id: '7.3',
    name: 'Securing offices, rooms and facilities',
    type: 'Control',
    category: 'Physical',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Physical security for offices, rooms, facilities and information processing facilities shall be designed and applied.'
  },
  {
    id: '7.4',
    type: 'Control',
    name: 'Physical security monitoring',
    category: 'Physical',
    status: 'Excluded',
    applicability: 'Excluded',
    description: 'Premises and physical security perimeters shall be continuously monitored for unauthorized physical access. (Excluded: AWS handles physical security monitoring for cloud infrastructure)'
  },
  {
    id: '7.5',
    type: 'Control',
    name: 'Protecting against physical and environmental threats',
    category: 'Physical',
    status: 'Excluded',
    applicability: 'Excluded',
    description: 'Physical protection against natural disasters, malicious attacks or accidents shall be designed and applied. (Excluded: AWS handles physical and environmental protection for cloud infrastructure)'
  },
  {
    id: '7.6',
    type: 'Control',
    name: 'Working in secure areas',
    category: 'Physical',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Procedures for working in secure areas shall be established, implemented and communicated to personnel.'
  },
  {
    id: '7.7',
    type: 'Control',
    name: 'Clear desk and clear screen',
    category: 'Physical',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Clear desk policy for papers and removable storage media and clear screen policy for information processing facilities shall be defined and appropriately enforced.'
  },
  {
    id: '7.8',
    type: 'Control',
    name: 'Equipment siting and protection',
    category: 'Physical',
    status: 'Excluded',
    applicability: 'Excluded',
    description: 'Equipment shall be sited and protected to reduce the risks from environmental threats and hazards, and opportunities for unauthorized access. (Excluded: AWS handles equipment siting and protection for cloud infrastructure)'
  },
  {
    id: '7.9',
    type: 'Control',
    name: 'Security of assets off-premises',
    category: 'Physical',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Security shall be applied to off-premises assets taking into account the different risks of working outside the organization\'s premises.'
  },
  {
    id: '7.10',
    type: 'Control',
    name: 'Storage media',
    category: 'Physical',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Storage media shall be managed through their life cycle of acquisition, use, transportation and disposal in accordance with the organization\'s classification scheme and handling requirements.'
  },
  {
    id: '7.11',
    type: 'Control',
    name: 'Supporting utilities',
    category: 'Physical',
    status: 'Excluded',
    applicability: 'Excluded',
    description: 'Information processing facilities shall be protected against power failures and other disruptions caused by failures in supporting utilities. (Excluded: AWS handles supporting utilities for cloud infrastructure)'
  },
  {
    id: '7.12',
    type: 'Control',
    name: 'Cabling security',
    category: 'Physical',
    status: 'Excluded',
    applicability: 'Excluded',
    description: 'Power and telecommunications cabling carrying data or supporting information services shall be protected from interception, interference or damage. (Excluded: AWS handles cabling security for cloud infrastructure)'
  },
  {
    id: '7.13',
    type: 'Control',
    name: 'Equipment maintenance',
    category: 'Physical',
    status: 'Excluded',
    applicability: 'Excluded',
    description: 'Equipment shall be correctly maintained to ensure availability, integrity and confidentiality of information. (Excluded: AWS handles equipment maintenance for cloud infrastructure)'
  },
  {
    id: '7.14',
    type: 'Control',
    name: 'Secure disposal or reuse of equipment',
    category: 'Physical',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Storage media, equipment and information shall be disposed of or reused in a secure manner.'
  },

  // A.8 Technological controls (34 controls)
  {
    id: '8.1',
    type: 'Control',
    name: 'User endpoint devices',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information processing facilities, including user endpoint devices, shall be managed consistent with the organization\'s information security policy.'
  },
  {
    id: '8.2',
    type: 'Control',
    name: 'Privileged access rights',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The allocation and use of privileged access rights shall be restricted and controlled.'
  },
  {
    id: '8.3',
    type: 'Control',
    name: 'Information access restriction',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Access to information and other associated assets shall be restricted in accordance with the access control topic-specific policy.'
  },
  {
    id: '8.4',
    type: 'Control',
    name: 'Access to source code',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Read and write access to source code, development tools and software libraries shall be restricted to authorized personnel only.'
  },
  {
    id: '8.5',
    type: 'Control',
    name: 'Secure authentication',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Secure authentication technologies and procedures shall be implemented based on information access restrictions and the topic-specific policy on access control.'
  },
  {
    id: '8.6',
    type: 'Control',
    name: 'Capacity management',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The use of resources shall be monitored, tuned and projections made of future capacity requirements to ensure the required system performance, availability and capacity.'
  },
  {
    id: '8.7',
    type: 'Control',
    name: 'Protection against malware',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Protection against malware shall be implemented and supported by appropriate user awareness.'
  },
  {
    id: '8.8',
    type: 'Control',
    name: 'Management of technical vulnerabilities',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information about technical vulnerabilities of information systems in use shall be obtained, the organization\'s exposure to such vulnerabilities evaluated and appropriate measures taken to address the associated risk.'
  },
  {
    id: '8.9',
    type: 'Control',
    name: 'Configuration management',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Configurations, including security configurations, of hardware, software, services and networks shall be established, documented, implemented, monitored and reviewed.'
  },
  {
    id: '8.10',
    type: 'Control',
    name: 'Information deletion',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information stored in information systems, devices or in any other storage media shall be deleted when no longer required.'
  },
  {
    id: '8.11',
    type: 'Control',
    name: 'Data masking',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Data masking shall be used in accordance with the organization\'s topic-specific policy on access control and other related topic-specific policies, and business requirements, taking applicable legislation into consideration.'
  },
  {
    id: '8.12',
    type: 'Control',
    name: 'Data leakage prevention',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Data leakage prevention measures shall be applied to systems, networks and any other devices that process, store or transmit sensitive information.'
  },
  {
    id: '8.13',
    type: 'Control',
    name: 'Information backup',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Backup copies of information, software and systems shall be maintained, tested regularly in accordance with the agreed topic-specific policy on backup.'
  },
  {
    id: '8.14',
    type: 'Control',
    name: 'Redundancy of information processing facilities',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information processing facilities shall be implemented with redundancy sufficient to meet availability requirements.'
  },
  {
    id: '8.15',
    type: 'Control',
    name: 'Logging',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Logging facilities and log information shall be protected against tampering and unauthorized access.'
  },
  {
    id: '8.16',
    type: 'Control',
    name: 'Monitoring activities',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Networks, systems and applications shall be monitored for anomalous behavior and appropriate actions taken to evaluate potential information security incidents.'
  },
  {
    id: '8.17',
    type: 'Control',
    name: 'Clock synchronization',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Clocks of all relevant information processing systems within an organization or security domain shall be synchronized to approved time sources.'
  },
  {
    id: '8.18',
    type: 'Control',
    name: 'Use of privileged utility programs',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The use of utility programs that might be capable of overriding system and application controls shall be restricted and tightly controlled.'
  },
  {
    id: '8.19',
    type: 'Control',
    name: 'Installation of software on operational systems',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Procedures for installation of software on operational systems shall be established and implemented.'
  },
  {
    id: '8.20',
    type: 'Control',
    name: 'Network security',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Networks and network services shall be secured.'
  },
  {
    id: '8.21',
    type: 'Control',
    name: 'Security of network services',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Security mechanisms, service levels and service requirements of network services shall be identified, implemented and monitored.'
  },
  {
    id: '8.22',
    type: 'Control',
    name: 'Segregation of networks',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Groups of information services, users and information systems shall be segregated on networks.'
  },
  {
    id: '8.23',
    type: 'Control',
    name: 'Web filtering',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Access to external websites shall be managed to reduce exposure to malicious content.'
  },
  {
    id: '8.24',
    type: 'Control',
    name: 'Use of cryptography',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Rules for the effective use of cryptography, including cryptographic key management, shall be defined and implemented.'
  },
  {
    id: '8.25',
    type: 'Control',
    name: 'Secure development life cycle',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Rules for the secure development of software and systems shall be established and applied.'
  },
  {
    id: '8.26',
    type: 'Control',
    name: 'Application security requirements',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Information security requirements shall be identified, specified and approved when developing or acquiring applications.'
  },
  {
    id: '8.27',
    type: 'Control',
    name: 'Secure system architecture and engineering principles',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Principles for engineering secure systems shall be established, documented, maintained and applied to any information system development activities.'
  },
  {
    id: '8.28',
    type: 'Control',
    name: 'Secure coding',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Secure coding principles shall be applied to software development.'
  },
  {
    id: '8.29',
    type: 'Control',
    name: 'Security testing in development and acceptance',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Security testing processes shall be defined and implemented in the development life cycle.'
  },
  {
    id: '8.30',
    type: 'Control',
    name: 'Outsourced development',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'The organization shall direct, monitor and review the activities related to outsourced system development.'
  },
  {
    id: '8.31',
    type: 'Control',
    name: 'Separation of development, test and production environments',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Development, test and production environments shall be separated and secured.'
  },
  {
    id: '8.32',
    type: 'Control',
    name: 'Change management',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Changes to information processing facilities and information systems shall be subject to change management procedures.'
  },
  {
    id: '8.33',
    type: 'Control',
    name: 'Test information',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Test information shall be appropriately selected, protected and managed.'
  },
  {
    id: '8.34',
    type: 'Control',
    name: 'Protection of information systems during audit testing',
    category: 'Technological',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Audit tests and other assurance activities involving assessment of operational systems shall be planned and agreed between the tester and appropriate management.'
  }
];

// Privacy controls organized by PIPEDA principles
export const privacyControls = [
  // Principle 1: Accountability
  {
    id: 'ACC-1',
    name: 'Privacy policies reviewed and complete',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have reviewed your privacy policies and are satisfied that they are complete and easy to understand.'
  },
  {
    id: 'ACC-2',
    name: 'Privacy governance responsibility delineated',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have clearly delineated who, within your organization, is responsible for privacy governance and management.'
  },
  {
    id: 'ACC-3',
    name: 'Privacy policies for employees and customers',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have privacy policies and practices that apply to the personal information of your employees as well as that of your customers.'
  },
  {
    id: 'ACC-4',
    name: 'Responsibility for transferred information',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy framework clearly articulates that you will be responsible for all personal information you hold or control, including information which has been transferred to a third party for processing.'
  },
  {
    id: 'ACC-5',
    name: 'PIPEDA contact person appointed',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have appointed at least one person to be responsible for the organization\'s overall compliance with PIPEDA.'
  },
  {
    id: 'ACC-6',
    name: 'PIPEDA contact information provided',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have directed staff through policy, procedure or training to provide the name, address and phone number of the PIPEDA contact person to individuals when requested.'
  },
  {
    id: 'ACC-7',
    name: 'Third-party contractual agreements',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You use contractual agreements to ensure a comparable level of privacy protection is offered to personal information while it is in the custody of a third party for processing.'
  },
  {
    id: 'ACC-8',
    name: 'Third-party privacy controls verified',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have verified that third parties have implemented the privacy controls stated in any contractual agreements.'
  },
  {
    id: 'ACC-9',
    name: 'Accountability for protection of personal information',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You are accountable for the protection of personal information.'
  },
  {
    id: 'ACC-10',
    name: 'Privacy policies communicated to staff',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have communicated information related to personal information handling policies, procedures and practices to staff.'
  },
  {
    id: 'ACC-11',
    name: 'Staff privacy training',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have trained staff regarding the protection of personal information by informing them of organizational privacy policies, procedures and best practices.'
  },
  {
    id: 'ACC-12',
    name: 'Privacy training identification process',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have the means in place to identify which of your staff should be trained in privacy, including new staff and refresher training of existing staff.'
  },
  {
    id: 'ACC-13',
    name: 'Public privacy documentation',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have developed documentation to explain your personal information protection policies and procedures to customers and the general public.'
  },
  {
    id: 'ACC-14',
    name: 'Employee privacy information',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have developed information to explain to your employees the policies and procedures which apply to their own personal information.'
  },
  {
    id: 'ACC-15',
    name: 'Privacy Impact Assessments conducted',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Privacy Impact Assessments are conducted for new projects, systems, or significant changes involving personal health information, as required by applicable provincial health privacy legislation.'
  },
  {
    id: 'ACC-16',
    name: 'Data processing records maintained',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Records of processing activities are maintained documenting data flows, processing purposes, data categories, and retention periods for personal health information.'
  },
  {
    id: 'ACC-17',
    name: 'Healthcare service provider assessments',
    category: 'Accountability',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Regular assessments are conducted of healthcare service providers, business associates, and agents handling personal health information to ensure compliance with contractual privacy obligations.'
  },

  // Principle 2: Identifying Purposes
  {
    id: 'ID-1',
    name: 'Purpose identified at or before collection',
    category: 'Identifying Purposes',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You identify why you are collecting personal information at or before the time of collection.'
  },
  {
    id: 'ID-2',
    name: 'Purpose documented',
    category: 'Identifying Purposes',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have documented your purpose(s) for collecting personal information.'
  },
  {
    id: 'ID-3',
    name: 'New purposes notification',
    category: 'Identifying Purposes',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have notified clients and customers of new purposes for which you will use information if they weren\'t identified at the time information was collected.'
  },
  {
    id: 'ID-4',
    name: 'Consent for new purposes',
    category: 'Identifying Purposes',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You seek the consent of clients and customers before using information for any new purpose if required.'
  },
  {
    id: 'ID-5',
    name: 'Notification when collection notification not practicable',
    category: 'Identifying Purposes',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have notified clients and customers of the purposes before using or disclosing the information if notification at the time of collection was not practicable.'
  },
  {
    id: 'ID-6',
    name: 'Privacy framework addresses identifying purpose',
    category: 'Identifying Purposes',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy framework addresses the principle of "identifying purpose" regarding personal information.'
  },

  // Principle 3: Consent
  {
    id: 'CON-1',
    name: 'Customer consent obtained',
    category: 'Consent',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You obtain customer consent for any collection, use or disclosure of personal information.'
  },
  {
    id: 'CON-2',
    name: 'PIPEDA Section 7 exception determination',
    category: 'Consent',
    status: 'Implemented',
    description: 'If you don\'t obtain customer consent for the collection, use and disclosure of personal information, you have determined that it is not required under s.7 of PIPEDA.'
  },
  {
    id: 'CON-3',
    name: 'Reasonable efforts for notification',
    category: 'Consent',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You make reasonable efforts to ensure that clients and customers are notified of the purposes for which personal information will be used or disclosed.'
  },
  {
    id: 'CON-4',
    name: 'No excessive consent requirements',
    category: 'Consent',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You do not require clients and customers to consent to the collection, use or disclosure of personal information beyond what is necessary to fulfill explicitly specified and limited purposes as a condition of supplying a product or service.'
  },
  {
    id: 'CON-5',
    name: 'Purpose assessment and limitation',
    category: 'Consent',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You assess the purposes and limit the collection, use and disclosure of personal information when it is required as a condition for obtaining a product or service.'
  },
  {
    id: 'CON-6',
    name: 'Consent obtained through lawful and fair means',
    category: 'Consent',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You obtain consent through lawful and fair means.'
  },
  {
    id: 'CON-7',
    name: 'Consent withdrawal allowed',
    category: 'Consent',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You allow a client or customer to withdraw consent at any time subject to legal or contractual restrictions and reasonable notice.'
  },
  {
    id: 'CON-8',
    name: 'Consent withdrawal implications explained',
    category: 'Consent',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You inform clients and customers of the implication of the withdrawal of consent.'
  },
  {
    id: 'CON-9',
    name: 'Consent form determination',
    category: 'Consent',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You consider the sensitivity and intended use of personal information, and the reasonable expectations of clients and customers in determining which form of consent (implied or expressed) you will accept for the collection, use and disclosure of personal information.'
  },
  {
    id: 'CON-10',
    name: 'Privacy framework addresses consent',
    category: 'Consent',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy framework addresses the principle of "consent" regarding personal information.'
  },
  {
    id: 'CON-11',
    name: 'Minors consent and parental authorization',
    category: 'Consent',
    status: 'Implemented',
    description: 'Special consent procedures are in place for minors\' personal health information, including requirements for parental or guardian authorization where applicable under provincial health privacy legislation.'
  },
  {
    id: 'CON-12',
    name: 'Research use consent and ethics approval',
    category: 'Consent',
    status: 'Implemented',
    description: 'Controls are in place for using personal health information for research purposes, including ethics board approval processes and appropriate consent mechanisms or consent waivers as permitted by law.'
  },

  // Principle 4: Limiting Collection
  {
    id: 'LC-1',
    name: 'Amount and type limited to necessity',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You limit the amount and type of personal information you collect to what is necessary for the identified purpose.'
  },
  {
    id: 'LC-2',
    name: 'Collection by fair and lawful means',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You collect information only by fair and lawful means.'
  },
  {
    id: 'LC-3',
    name: 'Collection types and purposes documented',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have documented the specific types of information you collect along with the purposes for collection.'
  },
  {
    id: 'LC-4',
    name: 'Third-party collection documented',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have documented when you collect information from sources other than the individual about whom it pertains.'
  },
  {
    id: 'LC-5',
    name: 'Mandatory vs optional collection distinguished',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You distinguish between mandatory and optional collection of personal information.'
  },
  {
    id: 'LC-6',
    name: 'SIN collection limited to legal purposes',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You limit your collection of the SIN to legally established purposes.'
  },
  {
    id: 'LC-7',
    name: 'Amount and types determined',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have determined the amounts and types of personal information needed to fulfill your purpose(s).'
  },
  {
    id: 'LC-8',
    name: 'Collection reasonableness determined',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have determined why you are collecting personal information and that the amount and types of personal information collected are reasonable in normal business circumstances.'
  },
  {
    id: 'LC-9',
    name: 'Essential vs non-essential information distinguished',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have distinguished between essential information (required for primary business purposes) and non-essential information (voluntary information which facilitates use for secondary purposes).'
  },
  {
    id: 'LC-10',
    name: 'Non-essential information opt-out process',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have identified non-essential information as voluntary and have provided staff with information on how to proceed when clients and customers opt out of secondary uses.'
  },
  {
    id: 'LC-11',
    name: 'Privacy framework addresses limiting collection',
    category: 'Limiting Collection',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy framework addresses the principle of "limiting collection" of personal information.'
  },

  // Principle 5: Limiting Use, Disclosure, and Retention
  {
    id: 'LUD-1',
    name: 'No use or disclosure beyond collection purpose',
    category: 'Limiting Use, Disclosure, and Retention',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You do not use or disclose information for purposes beyond those for which it was collected, except with the consent of the individual or as required by law.'
  },
  {
    id: 'LUD-2',
    name: 'New purposes documented',
    category: 'Limiting Use, Disclosure, and Retention',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You document new purposes conceived after the personal information is collected.'
  },
  {
    id: 'LUD-3',
    name: 'Retention limited to fulfillment of purposes',
    category: 'Limiting Use, Disclosure, and Retention',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You only retain personal information as long as necessary to allow for the fulfillment of identified purposes.'
  },
  {
    id: 'LUD-4',
    name: 'Decision-related information retention',
    category: 'Limiting Use, Disclosure, and Retention',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You retain personal information used to make decisions about an individual long enough for the individual to request access to it.'
  },
  {
    id: 'LUD-5',
    name: 'Information destruction framework',
    category: 'Limiting Use, Disclosure, and Retention',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy management framework governs the destruction of personal information, including the role of contractors performing such services.'
  },
  {
    id: 'LUD-6',
    name: 'Privacy framework addresses limiting use, disclosure and retention',
    category: 'Limiting Use, Disclosure, and Retention',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy framework addresses the principle of "limiting use, disclosure and retention" of personal information.'
  },
  {
    id: 'LUD-7',
    name: 'Right to erasure and deletion procedures',
    category: 'Limiting Use, Disclosure, and Retention',
    status: 'Implemented',
    description: 'Procedures are established for handling requests for erasure or deletion of personal health information, subject to legal retention requirements and regulatory obligations for medical records.'
  },
  {
    id: 'LUD-8',
    name: 'De-identification and anonymization procedures',
    category: 'Limiting Use, Disclosure, and Retention',
    status: 'Implemented',
    description: 'Procedures are established for de-identifying and anonymizing personal health information when used for secondary purposes such as research or analytics, including re-identification risk assessments.'
  },
  {
    id: 'LUD-9',
    name: 'Data portability mechanisms',
    category: 'Limiting Use, Disclosure, and Retention',
    status: 'Implemented',
    description: 'Mechanisms are in place to provide individuals with their personal health information in a structured, commonly used, and machine-readable format to facilitate data portability.'
  },

  // Principle 6: Accuracy
  {
    id: 'ACCY-1',
    name: 'Accuracy measures prior to decision-making',
    category: 'Accuracy',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You take reasonable measures to ensure that personal information is accurate, complete and up-to-date prior to using the information to make decisions.'
  },
  {
    id: 'ACCY-2',
    name: 'Updates limited to collection purposes',
    category: 'Accuracy',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You only update personal information if the process is necessary to fulfill the purposes for which the information was collected.'
  },
  {
    id: 'ACCY-3',
    name: 'Accuracy framework with challenge process',
    category: 'Accuracy',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy management framework addresses the accuracy, completeness and currency of personal information which includes a process through which individuals can challenge the accuracy of information.'
  },
  {
    id: 'ACCY-4',
    name: 'Update criteria specified',
    category: 'Accuracy',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy management framework specifies when updates are appropriate based on the defined purposes and uses of the information as well as the interests of the individual.'
  },
  {
    id: 'ACCY-5',
    name: 'Information collection and correction records',
    category: 'Accuracy',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You record when and where key information was collected, including dates of corrections or updates to such information.'
  },
  {
    id: 'ACCY-6',
    name: 'Periodic accuracy assessments',
    category: 'Accuracy',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You conduct periodic spot-checks, assessments or audits of information holdings and databases to ensure that key information is accurate, complete and up-to-date.'
  },
  {
    id: 'ACCY-7',
    name: 'Privacy framework addresses accuracy',
    category: 'Accuracy',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy framework addresses the principle of "accuracy" regarding personal information.'
  },

  // Principle 7: Safeguards
  {
    id: 'SAF-1',
    name: 'Physical, technical and administrative safeguards',
    category: 'Safeguards',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have adopted physical, technical and administrative safeguards to protect personal information against loss or theft as well as unauthorized access, disclosure, copying, use or modification.'
  },
  {
    id: 'SAF-2',
    name: 'Safeguards commensurate with sensitivity',
    category: 'Safeguards',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You choose security safeguards that are commensurate with the sensitivity of the information and the means used to transmit it.'
  },
  {
    id: 'SAF-3',
    name: 'Protection regardless of format',
    category: 'Safeguards',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You protect all personal information regardless of the format in which it is held.'
  },
  {
    id: 'SAF-4',
    name: 'Employee confidentiality awareness',
    category: 'Safeguards',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You make your employees aware of the importance of maintaining the confidentiality of personal information.'
  },
  {
    id: 'SAF-5',
    name: 'Secure disposal and destruction processes',
    category: 'Safeguards',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have implemented processes to prevent unauthorized access to personal information during the disposal or destruction of information.'
  },
  {
    id: 'SAF-6',
    name: 'Information security policies implemented',
    category: 'Safeguards',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have implemented and adhere to your various information security policies and practices.'
  },
  {
    id: 'SAF-7',
    name: 'Information security breach policy',
    category: 'Safeguards',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have established an information security breach policy and commit to investigating the root cause of such breaches.'
  },
  {
    id: 'SAF-8',
    name: 'Off-site information safeguards',
    category: 'Safeguards',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have developed and implemented policies and practices including appropriate safeguards for all uses of personal information outside the office.'
  },
  {
    id: 'SAF-9',
    name: 'Privacy framework addresses safeguards',
    category: 'Safeguards',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy framework addresses the principle of "safeguards" with respect to personal information.'
  },
  {
    id: 'SAF-10',
    name: 'Breach notification timelines and procedures',
    category: 'Safeguards',
    status: 'Implemented',
    description: 'Specific breach notification procedures are established with defined timelines for notifying regulatory bodies (Information and Privacy Commissioners) and affected individuals, as required by provincial health privacy legislation including PHIPA, HIA, HIPA, and PHIA.'
  },
  {
    id: 'SAF-11',
    name: 'Breach incident documentation and remediation',
    category: 'Safeguards',
    status: 'Implemented',
    description: 'All privacy breaches are documented, including root cause analysis, remediation actions taken, and measures implemented to prevent recurrence. Breach logs are maintained for regulatory reporting.'
  },
  {
    id: 'SAF-12',
    name: 'Comprehensive audit logging and monitoring',
    category: 'Safeguards',
    status: 'Implemented',
    description: 'Comprehensive audit logs are maintained for all access to, use of, and disclosure of personal health information. Access logs are regularly monitored and reviewed to detect unauthorized access patterns or suspicious activity.'
  },
  {
    id: 'SAF-13',
    name: 'Enhanced safeguards for sensitive health data',
    category: 'Safeguards',
    status: 'Implemented',
    description: 'Enhanced security safeguards are implemented for particularly sensitive categories of health information, such as mental health records, genetic information, or other highly sensitive health data, commensurate with the increased sensitivity.'
  },
  {
    id: 'SAF-14',
    name: 'Cross-border data transfer controls',
    category: 'Safeguards',
    status: 'Implemented',
    description: 'Controls are in place for cross-border transfers of personal health information, including adequacy assessments for foreign jurisdictions, contractual safeguards, and compliance with provincial restrictions (e.g., PIPA BC, Quebec Privacy Act) on data storage and processing outside Canada.'
  },

  // Principle 8: Openness
  {
    id: 'OPN-1',
    name: 'Policies and procedures available to individuals',
    category: 'Openness',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You make information regarding policies and procedures related to the management of personal information available to individuals.'
  },
  {
    id: 'OPN-2',
    name: 'Collection, use and disclosure explained',
    category: 'Openness',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You explain to customers why you collect, how you use and when you will disclose their personal information.'
  },
  {
    id: 'OPN-3',
    name: 'Contact information for questions and complaints',
    category: 'Openness',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You make information available to clients and customers regarding who within the organization can address questions or complaints regarding the handling of personal information.'
  },
  {
    id: 'OPN-4',
    name: 'Accountable person contact information available',
    category: 'Openness',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You make the name/title and address of the person accountable for the organization\'s privacy policies available on request.'
  },
  {
    id: 'OPN-5',
    name: 'Access and correction procedures described',
    category: 'Openness',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You describe to your clients how they can obtain access to or correct their personal information.'
  },
  {
    id: 'OPN-6',
    name: 'Personal information holdings and disclosures described',
    category: 'Openness',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You provide individuals with a description of what personal information you hold and what you disclose to other organizations.'
  },
  {
    id: 'OPN-7',
    name: 'Privacy framework addresses openness',
    category: 'Openness',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy framework addresses the principle of "openness" regarding personal information.'
  },

  // Principle 9: Individual Access
  {
    id: 'IA-1',
    name: 'PIPEDA access request policies and procedures',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have adopted policies and procedures for responding to requests for personal information under PIPEDA.'
  },
  {
    id: 'IA-2',
    name: 'Staff directed to access request handler',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have advised staff of the need to direct requests for access to information to the staff member responsible for processing these requests.'
  },
  {
    id: 'IA-3',
    name: 'Information existence, use and disclosure informed',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You inform individuals of the existence, use and disclosure of their personal information on receipt of a written request.'
  },
  {
    id: 'IA-4',
    name: 'Access provided on written request',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You provide individuals with access to personal information on receipt of a written request.'
  },
  {
    id: 'IA-5',
    name: 'Access refusal limited to PIPEDA Section 9 exceptions',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You limit refusal to provide access to information to exceptions described in Section 9 of PIPEDA.'
  },
  {
    id: 'IA-6',
    name: 'Account of information uses provided',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You provide an account of the uses of information on request.'
  },
  {
    id: 'IA-7',
    name: 'Third-party disclosure account provided',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You provide an account of all third parties to whom information has been disclosed (or a listing of the types of third parties to whom such information is generally disclosed) on receipt of a request for such a list from an individual.'
  },
  {
    id: 'IA-8',
    name: 'Assistance provided for access requests',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You assist those individuals who indicate they need help to complete a request for information.'
  },
  {
    id: 'IA-9',
    name: 'Minimal or no cost for access requests',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You respond to a request for information at minimal or no cost to the individual.'
  },
  {
    id: 'IA-10',
    name: '30-day response time with extension notification',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You respond to a request for information in not more than 30 days unless you notify the requestor within that time period of your need to extend the time limit for response, indicate the extended time limit and inform the requester of his or her right to complain to the OPC.'
  },
  {
    id: 'IA-11',
    name: 'Time limit extensions and format requirements',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You rely on time limit extensions only in cases where responding within the original 30 days would unreasonably interfere with your activities, when additional time is needed to conduct consultations, or when additional time is needed to convert personal information to an alternative format. You provide access to information in a format which is legible and will provide an explanation of abbreviations or codes on request from an individual.'
  },
  {
    id: 'IA-12',
    name: 'Refusal reasons and recourse advised',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You advise requestors of the reasons for refusal and recourse available to them when refusing to provide information.'
  },
  {
    id: 'IA-13',
    name: 'Information accuracy challenge and amendment',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You allow individuals to challenge the accuracy of personal information and amend information when an individual demonstrates that information is inaccurate or incomplete.'
  },
  {
    id: 'IA-14',
    name: 'Corrected information forwarded to third parties',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You forward corrected personal information to third parties who would have received the original information.'
  },
  {
    id: 'IA-15',
    name: 'Privacy framework addresses individual access',
    category: 'Individual Access',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy framework addresses the principle of "individual access" regarding personal information.'
  },
  {
    id: 'IA-16',
    name: 'Electronic health record portability',
    category: 'Individual Access',
    status: 'Implemented',
    description: 'Individuals can request and receive their personal health information in electronic format to facilitate portability and transfer to other healthcare providers or personal health record systems.'
  },

  // Principle 10: Challenging Compliance
  {
    id: 'CC-1',
    name: 'Compliance challenges to designated individual',
    category: 'Challenging Compliance',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You enable individuals to address compliance challenges to the designated individual responsible for PIPEDA.'
  },
  {
    id: 'CC-2',
    name: 'Complaint and inquiry policies and procedures',
    category: 'Challenging Compliance',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You have policies and procedures in place for receiving and responding to complaints or inquiries about your personal information handling policies and practices.'
  },
  {
    id: 'CC-3',
    name: 'Complaint processes and regulatory body rights advised',
    category: 'Challenging Compliance',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You advise individuals or complainants of the existence of all relevant complaint processes, including the right to make a complaint to a regulatory body.'
  },
  {
    id: 'CC-4',
    name: 'All complaints investigated',
    category: 'Challenging Compliance',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You investigate all complaints you receive about your personal information handling policies and practices.'
  },
  {
    id: 'CC-5',
    name: 'Corrective action for substantiated complaints',
    category: 'Challenging Compliance',
    status: 'Implemented',
    applicability: 'Included',
    description: 'You modify your actions if a complaint is substantiated, and take steps to minimize the likelihood that the issue will recur.'
  },
  {
    id: 'CC-6',
    name: 'Privacy framework addresses challenging compliance',
    category: 'Challenging Compliance',
    status: 'Implemented',
    applicability: 'Included',
    description: 'Your privacy framework addresses the principle of "challenging compliance" regarding personal information.'
  }
];

// Combined array for convenience (includes both ISMS requirements and Annex A controls)
export const allIso27001Controls = [...ismsRequirements, ...iso27001Controls];

// Helper functions
export const getRequirements = () => {
  return ismsRequirements;
};

export const getControls = () => {
  return iso27001Controls;
};

export const getControlsByCategory = (category) => {
  return allIso27001Controls.filter(control => control.category === category);
};

export const getControlsByStatus = (status) => {
  return allIso27001Controls.filter(control => control.status === status);
};

export const getControlsByType = (type) => {
  return allIso27001Controls.filter(control => control.type === type);
};

export const searchControls = (query) => {
  const lowerQuery = query.toLowerCase();
  return allIso27001Controls.filter(control => 
    control.id.toLowerCase().includes(lowerQuery) ||
    control.name.toLowerCase().includes(lowerQuery) ||
    control.description.toLowerCase().includes(lowerQuery)
  );
};

export const getAllCategories = () => {
  return [...new Set(allIso27001Controls.map(control => control.category))];
};

export const getAllStatuses = () => {
  return [...new Set(allIso27001Controls.map(control => control.status))];
};

